import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/bulk`;

export const ROUTE: RouteDefinition = `${baseRoute}/bulk`;

export const URL = (): RouteDefinition => `${baseRoute}/bulk`;
